// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2At5R","rootNoMargin":"styles_rootNoMargin__2Zc0w"};